import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import customersHeaders from "@/pages/Maintenance/Customers/customersHeaders";

export default {
	state: {
		customersListMod: null,
		customersList: null,
		customersFilters: null,
		customersTotals: null,
		customersLimit: null,
		customersOrder: null,
		customersSort: null,
		customersTotal: null,

		deleteExceptionList: [],
		deleteFilesList: [],
		logs: [],
		logsFilter: {},
		findUs: [],
	},
	mutations: {
		updateCustomersListMod(state, { rows, limit, order, sort, total }) {
			state.customersListMod = rows;
			state.customersLimit = limit;
			state.customersOrder = order;
			state.customersSort = sort;
			state.customersTotal = total;
			state.customersTotals = { id: total };
		},

		updateCustomersFilters(state, { filter }) {
			state.customersFilters = filter;
		},

		updateCustomersList(state, payload) {
			state.customersList = payload;
			state.logs = payload?.logs || [];
			state.logsFilter = payload?.logsFilter || {};
			state.findUs = payload?.find_us || [];
		},

		updateCustomer(state, payload) {
			const index = state.customersList.customers.findIndex(item => item.id === payload.id);
			if (index !== -1) {
				state.customersList.customers.splice(index, 1, payload);
			} else {
				state.customersList.customers.push(payload);
			}
		},

		updateDeleteException(state, { id, isDelete }) {
			if (isDelete) {
				state.deleteExceptionList = [];
			} else {
				state.deleteExceptionList.push(id);
			}
		},

		updateDeleteFiles(state, { id, isDelete }) {
			if (isDelete) {
				state.deleteFilesList = [];
			} else {
				state.deleteFilesList.push(id);
			}
		},
	},
	actions: {
		async getCustomers({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/customers/list', values);

				if (data && !data.status) {
					commit('updateCustomersListMod', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.TRUCKS, defaultHeader: customersHeaders });
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getCustomersFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/customers/filters', values);
				if (data) commit('updateCustomersFilters', data);
			} catch (e) {
				console.error(e);
			}
		},

		async onCustomersRemoveItem({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.delete(`/customers/${ id }`);
				if (data.status) {
					return data;
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		getDeleteException({ commit }, { id, isDelete }) {
			commit('updateDeleteException', { id, isDelete });
		},

		async onDeleteException({ state }) {
			if (state.deleteExceptionList.length) await httpClient.post(`/customers/deleteExceptions`, { ids: state.deleteExceptionList });
		},

		getDeleteFiles({ commit }, { id, isDelete }) {
			commit('updateDeleteFiles', { id, isDelete });
		},

		async onDeleteFiles({ state }) {
			if (state.deleteFilesList.length) await httpClient.post(`/customers/deleteFail`, { ids: state.deleteFilesList });
		},

		async getCustomerDetails({ commit, dispatch }, value) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/customers/${ value }`);
				if (data && !data.status) {
					commit("updateCustomersList", data);
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onCreateCustomer({ dispatch }, { type, values }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post(`customers/${ type }`, values);

				if (data && !data.error) {
					return data;
				}

			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		onClearCustomerList({ commit }) {
			commit('updateCustomersList', null);
		}

	},
	getters: {
		customersListMod: (s) => s.customersListMod,
		customersList: (s) => s.customersList,
		customersFilters: (s) => s.customersFilters,
		customersTotals: (s) => s.customersTotals,
		customersLimit: (s) => s.customersLimit,
		customersOrder: (s) => s.customersOrder,
		customersSort: (s) => s.customersSort,
		customersTotal: (s) => s.customersTotal,

		logs: s => s.logs,
		logsFilter: s => s.logsFilter,
		findUs: s => s.findUs
	}
};
